
import CourseGroupIndex from '../components/course_groups/CourseGroupIndex.vue';
import Vue from 'vue';

Vue.component('course-group-index', CourseGroupIndex);

export default Vue.extend({});
